const TickIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.80412 0H17.2081C21.2761 0 24.0001 2.856 24.0001 7.104V16.9092C24.0001 21.144 21.2761 24 17.2081 24H6.80412C2.73612 24 0.00012207 21.144 0.00012207 16.9092V7.104C0.00012207 2.856 2.73612 0 6.80412 0ZM11.3161 15.5881L17.0161 9.88814C17.4241 9.48014 17.4241 8.82014 17.0161 8.40014C16.6081 7.99214 15.9361 7.99214 15.5281 8.40014L10.5721 13.3561L8.47205 11.2561C8.06405 10.8481 7.39205 10.8481 6.98405 11.2561C6.57605 11.6641 6.57605 12.3241 6.98405 12.7441L9.84005 15.5881C10.0441 15.7921 10.3081 15.8881 10.5721 15.8881C10.8481 15.8881 11.1121 15.7921 11.3161 15.5881Z"
        fill="#1660CD"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2081 1H6.80412C5.0129 1 3.58294 1.62324 2.59879 2.65072C1.61106 3.68193 1.00012 5.19677 1.00012 7.104V16.9092C1.00012 18.809 1.61057 20.3206 2.59833 21.3505C3.58261 22.3767 5.01285 23 6.80412 23H17.2081C18.9992 23 20.426 22.3769 21.407 21.3514C22.3919 20.3219 23.0001 18.8103 23.0001 16.9092V7.104C23.0001 5.19555 22.3914 3.68059 21.4066 2.64981C20.4256 1.62308 18.9992 1 17.2081 1ZM17.2081 0H6.80412C2.73612 0 0.00012207 2.856 0.00012207 7.104V16.9092C0.00012207 21.144 2.73612 24 6.80412 24H17.2081C21.2761 24 24.0001 21.144 24.0001 16.9092V7.104C24.0001 2.856 21.2761 0 17.2081 0Z"
        fill="#1660CD"
      />
    </svg>
  );
};

export default TickIcon;
